import { Route, Routes } from 'react-router-dom';
import TunnelSelection from '../pages/TunnelSelection/TunnelSelection';
import OrderTracking from '../pages/OrderTracking/OrderTracking';
import BrandSelection from '../pages/BrandSelection/BrandSelection';
import ModelSelection from '../pages/ModelSelection/ModelSelection';
import SizeSelection from '../pages/SizeSelection/SizeSelection';
import GumSelection from '../pages/GumSelection/GumSelection';
import ServiceSelection from '../pages/ServiceSelection/ServiceSelection';
import ShoeSummary from '../pages/ShoeSummary/ShoeSummary';
import ClientInfoForm from '../pages/ClientInfoForm/ClientInfoForm';
import OrderSummary from '../pages/OrderSummary/OrderSummary';
import TicketScreen from '../pages/TicketScreen/TicketScreen';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<TunnelSelection />} />
      <Route path="/suivre-commande" element={<OrderTracking />} />
      <Route path="/nouvelle-demande/marque" element={<BrandSelection />} />
      <Route path="/nouvelle-demande/modele" element={<ModelSelection />} />
      <Route path="/nouvelle-demande/pointure" element={<SizeSelection />} />
      <Route path="/nouvelle-demande/gomme" element={<GumSelection />} />
      <Route path="/nouvelle-demande/service" element={<ServiceSelection />} />
      <Route
        path="/nouvelle-demande/recapitulatif-chaussure"
        element={<ShoeSummary />}
      />
      <Route
        path="/nouvelle-demande/coordonnees"
        element={<ClientInfoForm />}
      />
      <Route
        path="/nouvelle-demande/recapitulatif-commande"
        element={<OrderSummary />}
      />
      <Route path="/nouvelle-demande/tickets" element={<TicketScreen />} />
    </Routes>
  );
}
